module.exports = __webpack_public_path__ + "img/brandNewPart.606cb4a1.png";